import { useEffect, useState } from 'react';
import Tile from '../../widgets/tile';
//import ReactTable from '../../tables/reactTable';
import Line from '../../charts/line';
import Bar from '../../charts/bar';
import { overview as overviewTiles } from '../../helpers/tiles';
import TableSkeleton from '../../loaders/table';
import BarGraph from '../../loaders/bar-graph';
import LineGraph from '../../loaders/line-graph';
import Box from '../../loaders/box';
import DateRangeFilter from '../../comman/datepicker/NewDatePicker';
import useAuthentication from '../../contexts/OverViewContext';
import consumerData from '../../contexts/OverViewContext';
import OverViewTable from '../../tables/overview';
import TextSkeleton from '../../loaders/text';

const css = {
  minCol: {
    minWidth: 'fit-content',
  },
  maxCol: {
    maxWidth: 'fit-content',
  },
};

const InventoryOverview = (props: any) => {
  const { inventoryOverviewAPI }: any = useAuthentication();
  const {
    inventoryOverviewData,
    setInventoryOverviewData,
    inventoryOverviewTilesData,
    setInventoryOverviewTilesData,
    sDateRangeInventoryOverview,
    dateRangeInventoryOverview,
  }: any = consumerData();

  const { empty } = props;

  const [random, sRandom] = useState(Math.random());
  const [selectedTile, sSelectedTile] = useState<any>(0);
  const [lineData, sLineData] = useState<any>(null);
  const [barData, sBarData] = useState<any>(null);
  const [refinedBarData, sRefinedBarData] = useState<any>([]);
  const [refinedLineData, sRefinedLineData] = useState<any>([]);
  const [skeleton, sSkeleton] = useState(true);
  const [rawBarData, sRawBarData] = useState<any>([]);
  const [attribute, sAttribute] = useState<any>(null);
  const [rawLineData, sRawLineData] = useState<any>([]);
  const [dateChange, setDateChange] = useState(false);

  // const [selectionRange, setSelectionRange] = useState({
  //   startDate: new Date(new Date().setDate(new Date().getDate() - 6)),
  //   endDate: new Date(),
  //   key: 'selection',
  // });

  const GetSelectionRangeProps = (data: any) => {
    //setSelectionRange(data);
    sDateRangeInventoryOverview(data);
    selectTile(0);
    if (data.startDate !== data.endDate) {
      setDateChange(true);
    }
  };

  const convert = (str: any) => {
    const date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join('-');
  };

  useEffect(() => {
    if (Object.keys(inventoryOverviewData).length === 0) {
      // Only make the API call when overviewData is empty and selectionRange is defined
      getOverviewData();
    } else {
      sSkeleton(false); // If data is already present, setSkeleton to false
    }
  }, [inventoryOverviewData]);

  useEffect(() => {
    if (
      dateChange &&
      convert(dateRangeInventoryOverview?.startDate) !==
        convert(dateRangeInventoryOverview?.endDate)
    )
      getOverviewData();
    setDateChange(false);
  }, [dateChange]);

  // useEffect(() => {
  //   if (
  //     convert(dateRangeInventoryOverview?.startDate) !==
  //     convert(dateRangeInventoryOverview?.endDate)
  //   ) {
  //     getOverviewData();
  //   }
  // }, [dateRangeInventoryOverview]);

  const getOverviewData = () => {
    const payload = {
      start_date: convert(dateRangeInventoryOverview.startDate) || '',
      end_date: convert(dateRangeInventoryOverview.endDate) || '',
      time_zone: 'Asia/Kolkata',
    };
    if (dateRangeInventoryOverview.startDate !== dateRangeInventoryOverview.endDate) {
      sSkeleton(true);
      inventoryOverviewAPI(payload)
        .then((data: any) => {
          if (data) {
            setInventoryOverviewData(data);
            const tileData = overviewTiles(data?.total);
            setInventoryOverviewTilesData(tileData);
            sRandom(Math.random());
            selectTile(0);
            sSkeleton(false);
            setDateChange(false);
          }
        })
        .catch((error: any) => {
          // Handle error if needed
        });
    }
  };

  const selectTile = (id: number) => {
    sSelectedTile(id);
  };

  useEffect(() => {
    sBarData(inventoryOverviewTilesData?.find((x: any) => x.id === selectedTile)?.barData ?? []);
    sLineData(inventoryOverviewTilesData?.find((x: any) => x.id === selectedTile)?.lineData ?? []);
  }, [selectedTile, random]);

  useEffect(() => {
    const bottom: any = [];
    rawBarData.map((_: any, i: any) => {
      return bottom.push({ tag: _.tag, [attribute]: _[attribute] });
    });
    const top = bottom.sort((a: any, b: any) => b[attribute] - a[attribute]).slice(0, 5);
    sRefinedBarData({
      labels: top.map((a: any) => a.tag),
      values: top.map((a: any) => a[attribute]),
    });
  }, [rawBarData, attribute]);

  useEffect(() => {
    if (barData && barData.length) {
      const newData = barData
        .sort((a: any, b: any) => b[Object.keys(b)[0]] - a[Object.keys(a)[0]])
        .slice(0, 5);
      let newlabels: any = [];
      newlabels = newData.map((_: any) => _[Object.keys(_)[1]]);
      let newValues: any = [];
      newValues = newData.map((_: any) => _[Object.keys(_)[0]]);
      sRefinedBarData({ labels: newlabels, values: newValues });
    }
  }, [barData]);

  useEffect(() => {
    const bottom: any = [];
    rawLineData.map((_: any, i: any) => {
      return bottom.push({ date: _.date, [attribute]: _[attribute] });
    });
    sRefinedLineData({
      labels: bottom.map((a: any) => a.date),
      values: bottom.map((a: any) => a[attribute]),
    });
  }, [rawLineData, attribute]);

  useEffect(() => {
    if (lineData && lineData.length) {
      let newlabels: any = [];
      newlabels = lineData.map((_: any) => _[Object.keys(_)[1]]);
      let newValues: any = [];
      newValues = lineData.map((_: any) => _[Object.keys(_)[0]]);
      /* replace new value array */
      //sRefinedLineData({ labels: newlabels, values: newValues });
      sRefinedLineData({ labels: newValues, values: newlabels });
    } else {
      sRefinedLineData({ labels: [], values: [] });
    }
  }, [lineData]);

  return (
    <>
      <div className='row justify-content-between'>
        <div className='col col-6'>
          {skeleton ? <TextSkeleton height={26} width={100} lineCount={1} /> : <h2>Overview</h2>}
        </div>
        <div className={'col col-6'} style={{ position: 'relative' }}>
          {skeleton ? (
            <TextSkeleton height={26} width={230} lineCount={1} />
          ) : (
            <DateRangeFilter
              onChange={GetSelectionRangeProps}
              selectionRange={dateRangeInventoryOverview}
            />
          )}
        </div>
      </div>
      <div className={'row overview-tiles'} style={{ marginTop: 65 }}>
        <div className={'col'} style={css.maxCol}>
          <div className={'row'}>
            {skeleton ? (
              <div className='col-6 d-flex gap-4'>
                {[1, 2, 3, 4, 5, 6].map((index) => {
                  return <Box key={index} />;
                })}
              </div>
            ) : (
              <>
                {inventoryOverviewTilesData.length > 0 &&
                  inventoryOverviewTilesData.map((tile: any, index: any) => {
                    return (
                      <div key={index} className={'col'} style={css.minCol}>
                        <Tile
                          id={tile.id}
                          selected={selectedTile}
                          click={selectTile}
                          label={tile.label}
                          value={tile.value}
                          info={tile.info}
                          arrow={tile.arrow}
                        />
                      </div>
                    );
                  })}
              </>
            )}
          </div>
        </div>
      </div>
      <div
        className={'row overview-graphs'}
        style={{
          marginTop: 24,
          marginLeft: 0,
          marginRight: 0,
          minHeight: '250px',
          maxHeight: 'fit-content',
          borderRadius: '4px',
          padding: '24px',
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.05)',
        }}
      >
        <div className={'col'} style={{ maxWidth: '50%' }}>
          {skeleton ? (
            <BarGraph empty={empty} />
          ) : (
            <Bar label={'Impressions'} data={refinedBarData} attribute={attribute} />
          )}
        </div>
        <div className={'col'} style={{ maxWidth: '50%' }}>
          {skeleton ? (
            <LineGraph empty={empty} />
          ) : (
            <Line label={'Impressions'} data={refinedLineData} attribute={attribute} />
          )}
        </div>
      </div>
      <div className='row overview-tables'>
        {skeleton ? (
          <div className='pt-5'>
            <TableSkeleton columns={5} rows={3} rowSpacing={10} tableHeight={150} />
          </div>
        ) : (
          <>
            <OverViewTable
              tableColumns={inventoryOverviewData?.table?.columns ?? []}
              tableRows={inventoryOverviewData?.table?.data ?? []}
              search={true}
              searchPlaceholder={'Search Here...'}
              downloadCSV={true}
            />
            {/* <InfyTable
                data={inventoryOverviewData?.table?.data ?? []}
                columns={inventoryOverviewData?.table?.columns ?? []}
                search={true}
                columnWidth={150}
              /> */}
          </>
        )}
      </div>
    </>
  );
};

export default InventoryOverview;
